// src/AudioRecognition/util/note.ts
export function hzToMidi(hz: number): number {
  return 69 + 12 * Math.log2(hz / 440);
}
export function midiToHz(midi: number): number {
  return 440 * Math.pow(2, (midi - 69) / 12);
}
const NAMES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
const NAME_TO_SEMITONE: Record<string, number> = {
  C: 0,
  D: 2,
  E: 4,
  F: 5,
  G: 7,
  A: 9,
  B: 11,
};

export function midiToName(midi: number): string {
  const n = Math.round(midi);
  const name = NAMES[((n % 12) + 12) % 12];
  const oct = Math.floor(n / 12) - 1;
  return `${name}${oct}`;
}
export function hzToName(hz: number | null | undefined): string | null {
  if (!hz || hz <= 0) return null;
  return midiToName(hzToMidi(hz));
}

export function noteNameToMidi(value: string): number | null {
  const trimmed = value.trim();
  const match = /^([A-Ga-g])([#♯b♭]?)(-?\d+)$/.exec(trimmed);
  if (!match) return null;

  const [, rawName, rawAccidental, rawOctave] = match;
  const base = NAME_TO_SEMITONE[rawName.toUpperCase()];
  const accidental = rawAccidental === '#' || rawAccidental === '♯' ? 1 : rawAccidental ? -1 : 0;
  const octave = Number.parseInt(rawOctave, 10);
  const midi = (octave + 1) * 12 + base + accidental;

  return Number.isInteger(midi) && midi >= 0 && midi <= 127 ? midi : null;
}

export function parseMidiOrNoteName(value: string): number | null {
  const trimmed = value.trim();
  if (!trimmed) return null;

  if (/^-?\d+$/.test(trimmed)) {
    const midi = Number.parseInt(trimmed, 10);
    return midi >= 0 && midi <= 127 ? midi : null;
  }

  return noteNameToMidi(trimmed);
}
